export const getColumnWidth = (rows, column) => {
  const minWidth = 10;
  const maxWidth = 2000;
  const magicSpacing = 10;
  const accessor = column.accessor;
  const headerText = column.Header;

  if (column.width) {
    return Math.min(maxWidth, column.width * magicSpacing);
  }
  const cellLength = Math.max(
    ...rows.map(row => {
      const value = typeof accessor === "function" ? accessor(row) : `${row[accessor]}` || "";
      return value !== undefined && value !== null ? value.toString().length : minWidth;
    }),
    headerText.length,
  );
  return Math.min(maxWidth, cellLength * magicSpacing);
};
